/*
 * В макете тултипа нет — 21 подсказка сделана нативным `title=`, кастомного тултипа среди них
 * ни одного (проверено грепом по `title="` и по слову «tooltip»). Вид спроектирован по Step 3
 * брифа («тёмная плашка, 11px, border-radius: 6px, задержка 400 мс») и существующим токенам,
 * а не перенесён:
 * - `background:var(--ink);color:var(--bg)` — не новая пара цветов, а тот же «тёмный чип»,
 *   которым в макете красятся акцентные кнопки-пилюли («Сервис «Компании»» строка 163,
 *   «Личный кабинет» строка 224, «Новая бронь» в нав-баре строка 241 — везде буквально
 *   `background:var(--ink);color:var(--bg)`);
 * - `box-shadow:var(--shadow-pop)` — та же тень, что у Popover/DropdownMenu, других теней для
 *   «плавающих» слоёв в токенах нет;
 * - анимация — `pop-in`, укороченный до 120мс (сам keyframe тот же, что красит всплывающие
 *   элементы макета, например строка 147: `animation:pop-in .3s cubic-bezier(.16,1,.3,1) both`).
 */
.content {
  max-width: 240px;
  background: var(--ink);
  color: var(--bg);
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  padding: 5px 9px;
  border-radius: 6px;
  box-shadow: var(--shadow-pop);
  z-index: 70;
}

.content[data-state='delayed-open'],
.content[data-state='instant-open'] {
  animation: 0.12s var(--ease-out) both;
  /* global(): иначе имя захешируется и анимация не сыграет — см. shared/styles/animations.css */
  animation-name: global(pop-in);
}
